module.exports = __webpack_public_path__ + "static/media/attack-number-6.8ef62ee5.png";